import { render, staticRenderFns } from "./Fund-ReitsPop.vue?vue&type=template&id=651e2d9f&"
import script from "./Fund-ReitsPop.vue?vue&type=script&lang=js&"
export * from "./Fund-ReitsPop.vue?vue&type=script&lang=js&"
import style0 from "./Fund-ReitsPop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports